// @flow

import React from 'react'
// $FlowFixMe
import * as Sentry from '@sentry/browser'
import { Provider } from 'react-redux'
// $FlowFixMe
import { ConnectedRouter } from 'connected-react-router'
import { ThemeProvider } from 'styled-components'
// $FlowFixMe
import { StripeProvider } from 'react-stripe-elements'

import { theme } from 'src/theme/globalStyle'
import Routes from 'src/config/routes'
import history from 'src/config/history'
import ScrollToTop from 'src/components/ScrollToTop'

type Props = {
  store: Object
}

type Props_ = {
  children?: any
}

type State = {
  error?: any
}

class Boundary extends React.Component<Props_, State> {
  state = { error: null }
  componentDidCatch(error, errorInfo) {
    this.setState({ error })
    process.env.NODE_ENV !== 'development' &&
      Sentry.withScope(scope => {
        Object.keys(errorInfo).forEach(key => {
          scope.setExtra(key, errorInfo[key])
        })
        Sentry.captureException(error)
      })
  }
  render() {
    if (this.state.error) {
      //render fallback UI
      return <a onClick={() => Sentry.showReportDialog()}>Report feedback</a>
    } else {
      //when there's not an error, render children untouched
      return this.props.children
    }
  }
}

const Root = ({ store }: Props) => {
  const { router = {} } = store.getState()
  const { location = {} } = router
  const { pathname = '' } = location
  const token = pathname.includes('tccw')
    ? process.env.REACT_APP_STRIPE_TOKEN_CW
    : process.env.REACT_APP_STRIPE_TOKEN
  return (
    <Provider store={store}>
      <Boundary>
        <StripeProvider apiKey={token}>
          <ThemeProvider theme={theme}>
            <ConnectedRouter history={history}>
              <ScrollToTop>
                <Routes />
              </ScrollToTop>
            </ConnectedRouter>
          </ThemeProvider>
        </StripeProvider>
      </Boundary>
    </Provider>
  )
}

export default Root



// WEBPACK FOOTER //
// ./src/components/Root/index.js